<template>
  <v-app class="login-app" :class="{ 'dark-mode': isDarkMode }">
    <v-main class="login-main" style="padding:0px!important;margin-top: 0px;">
      <!-- Background with cars -->
      <div class="login-background" :class="{ 'dark-bg': isDarkMode }" :style="`background-image: url(${currentBackground})`">
        <!-- Dark Mode Toggle -->
        <div class="mode-toggle">
          <v-btn icon small @click="toggleDarkMode" class="mode-btn">
            <v-icon small>{{ isDarkMode ? 'fa-sun' : 'fa-moon' }}</v-icon>
          </v-btn>
        </div>
        <!-- Logo at top -->
        <div class="logo-container">
          <img :src="inventoryLogo" alt="Herrera Luxury Auto Sales" class="autosyncx-logo-img" />
        </div>

        <!-- Login Card -->
        <v-card class="login-card mx-auto" :class="{ 'dark-card': isDarkMode }" :width="$vuetify.breakpoint.xs ? '95%' : '450px'" elevation="5">
          <!-- Purple accent bar at top -->
          <div class="card-accent-bar"></div>

          <div class="card-content pa-6">
            <!-- Welcome text -->
            <h2 class="welcome-title text-center mb-2">Welcome to <span class="brand-text">Herrera Luxury Auto Sales</span></h2>
            <p class="subtitle text-center mb-6">Please select how you'd like to sign in.</p>

            <!-- Select Portal Accordion -->
            <div class="portal-section mb-4">
              <div class="portal-header" @click="portalExpanded = !portalExpanded">
                <span class="portal-label">Select Portal</span>
                <v-icon class="expand-icon" :class="{ 'rotate-icon': portalExpanded }">fa-chevron-down</v-icon>
              </div>

              <v-expand-transition>
                <div v-show="portalExpanded" class="portal-options">
                  <div
                    v-for="(portal, index) in portals"
                    :key="index"
                    class="portal-option"
                    :class="{ 'selected': selectedPortal === portal.value }"
                    @click="selectPortal(portal.value)"
                  >
                    <v-icon class="portal-icon" :class="{ 'selected-icon': selectedPortal === portal.value }">
                      {{ portal.icon }}
                    </v-icon>
                    <span class="portal-name">
                      <template v-if="portal.highlight">
                        <strong>{{ portal.highlight }}</strong> <em>{{ portal.suffix }}</em>
                      </template>
                      <template v-else>
                        {{ portal.label }}
                      </template>
                    </span>
                    <v-icon v-if="selectedPortal === portal.value" class="check-icon">fa-check</v-icon>
                  </div>
                </div>
              </v-expand-transition>
            </div>

            <!-- Email Field -->
            <v-text-field
              v-model="email"
              label="Email"
              type="email"
              outlined
              dense
              :dark="isDarkMode"
              class="login-input mt-2"
              :background-color="isDarkMode ? 'rgba(40, 40, 60, 0.9)' : ''"
              prepend-inner-icon="fa-envelope"
              @keyup.enter="handleLogin"
            ></v-text-field>

            <!-- Password Field -->
            <v-text-field
              v-model="password"
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              :dark="isDarkMode"
              class="login-input"
              :background-color="isDarkMode ? 'rgba(40, 40, 60, 0.9)' : ''"
              prepend-inner-icon="fa-lock"
              :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="handleLogin"
            ></v-text-field>

            <!-- Forgot Password Link -->
            <div class="text-right mb-3">
              <a @click="forgotPasswordDialog = true" class="forgot-link">Forgot Password?</a>
            </div>

            <!-- Login Button -->
            <v-btn
              block
              height="48"
              class="login-btn mb-3"
              :disabled="!selectedPortal || !email || !password || loginLoading"
              :loading="loginLoading"
              @click="handleLogin"
            >
              Log In
            </v-btn>

            <!-- Sign up link -->
            <div class="text-center signup-text">
              <span>Don't have an account? </span>
              <a @click="$router.push('/signup')" class="signup-link"><strong>Sign up</strong></a>
            </div>
          </div>
        </v-card>

        <!-- Footer text -->
        <div class="footer-text">
          Not sure which portal to use? Contact your Administrator.
        </div>
      </div>
    </v-main>
  </v-app>
</template>
<script>
import AppBarBlurAuth from "@/components/AppBarBlurAuth";
import { FadeTransition } from "vue2-transitions";

export default {
  name: "page-layout",
  components: {
    AppBarBlurAuth,
    FadeTransition,
  },
  data() {
    return {
      checkbox: false,
      showpassword: false,
      email: '',
      password: '',
      showPassword: false,
      dialog: false,
      logo_background_light: require('@/assets/img/bg-inventory.jpeg'),
      logo_background_dark: require('@/assets/img/bg-inventory.jpeg'),
      inventoryLogo: require('@/assets/img/inventory-logo.png'),
      pageFlag: 'init',
      backgroundLogo: localStorage.getItem('admin_bg'),
      isDarkMode: false,
      buttonFlag: false,
      loadingLogo: false,
      url: '',
      company: '',
      loadingFlag: false,
      base_url_img: process.env.VUE_APP_WASBI_URL,
      loginLoading: false,
      forgotPasswordDialog: false,
      forgotEmail: '',
      // New portal selection data
      portalExpanded: true,
      selectedPortal: 'admin',
      portals: [
      
        { value: 'admin', label: 'Admin Portal', icon: 'fa-user-shield', highlight: null, suffix: null },
      ],
      // Portal API mapping
      portalApiMap: {
        'dealer': '/api/auth/login-dealer',
        'referring': '/api/auth/authenticate',
        'sales': '/api/auth/authenticate',
        'lead': '/api/auth/authenticate',
        'admin': '/api/auth/login-admin'
      },
      // Portal URL param mapping
      portalParamMap: {
        'dealer': 'dealer',
        'dealership': 'dealer',
        'referring': 'referring',
        'agent': 'referring',
        'sales': 'sales',
        'lead': 'lead',
        'admin': 'admin'
      }
    };
  },
  beforeCreate: function () {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('is_admin') && localStorage.getItem('is_admin') == 1)
        this.$router.push('/admin/dashboard')
      else
        this.$router.push('/dashboard')
    }
  },
  created: function () {
    this.url = window.location.origin;
    if (this.url)
      this.getCompanyInfo(this.url);
    else
      this.loadingFlag = true;

    // Check URL query parameter for portal selection
    this.checkPortalParam();

    // Check saved dark mode preference
    const savedDarkMode = localStorage.getItem('login_dark_mode');
    if (savedDarkMode !== null) {
      this.isDarkMode = savedDarkMode === 'true';
    } else {
      // Check system preference
      this.isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
  },
  computed: {
    currentBackground() {
      return this.isDarkMode ? this.logo_background_dark : this.logo_background_light;
    }
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('login_dark_mode', this.isDarkMode.toString());
    },
    checkPortalParam() {
      // Check for portal query parameter (e.g., /login?portal=dealer)
      const urlParams = new URLSearchParams(window.location.search);
      const portalParam = urlParams.get('portal');

      if (portalParam) {
        const mappedPortal = this.portalParamMap[portalParam.toLowerCase()];
        if (mappedPortal) {
          this.selectedPortal = mappedPortal;
        }
      }
    },
    selectPortal(portal) {
      this.selectedPortal = portal;
    },
    goToPortalLogin() {
      if (!this.selectedPortal) {
        Vue.$toast.error('Please select a portal', { position: 'top-right' });
        return;
      }
      localStorage.setItem('selected_portal', this.selectedPortal);
    },
    async handleLogin() {
      if (!this.selectedPortal) {
        Vue.$toast.error('Please select a portal', { position: 'top-right' });
        return;
      }
      if (!this.email) {
        Vue.$toast.error('Email is required', { position: 'top-right' });
        return;
      }
      if (!this.password) {
        Vue.$toast.error('Password is required', { position: 'top-right' });
        return;
      }

      this.loginLoading = true;
      const apiEndpoint = this.portalApiMap[this.selectedPortal];

      try {
        const response = await axios.post(apiEndpoint, {
          email: this.email,
          password: this.password
        });

        const data = response.data;

        if (data.flag === 1) {
          // Store authentication data
          localStorage.setItem('token', data.token.token);
          localStorage.setItem('user_id', data.data.user_id);
          localStorage.setItem('user_name', (data.data.first_name || '') + ' ' + (data.data.last_name || ''));
          localStorage.setItem('user_email', data.data.email);
          localStorage.setItem('selected_portal', this.selectedPortal);

          // Store role information
          if (data.data.roles && data.data.roles.length > 0) {
            localStorage.setItem('role', JSON.stringify(data.data.roles[0]));
          }

          // Handle portal-specific data
          if (this.selectedPortal === 'dealer') {
            // Match DealerLogin.vue exactly
            localStorage.setItem('user_flag', data.data.flag);
            localStorage.setItem('business_name', data.data.business_name || '');

            // Store dealer-specific data
            if (data.data.dealer_info) {
              localStorage.setItem('dealer_id', data.data.dealer_info.dealer_id);
              localStorage.setItem('dealer_status', data.data.dealer_info.status);
            }

            Vue.$toast.success('Login successful! Welcome to your dealer dashboard.', { position: 'top-right' });
            this.$router.push('/dealers/dashboard');
          } else if (this.selectedPortal === 'admin') {
            const result = data.data;
            // Store all admin data (matching LoginAdmin.vue to avoid auto-logout)
            localStorage.setItem('is_admin', result.is_admin || '1');
            localStorage.setItem('first_name', result.first_name || '');
            localStorage.setItem('email', result.email || '');
            localStorage.setItem('phone', result.phone_m || '');
            localStorage.setItem('name', (result.first_name || '') + ' ' + (result.last_name || ''));
            localStorage.setItem('company_name', result.company_name || '');
            if (result.logo) {
              localStorage.setItem('company_logo', process.env.VUE_APP_WASBI_URL + result.logo);
            }
            if (result.company_id) {
              localStorage.setItem('company_id', result.company_id);
            }
            if (result.roles && result.roles.length > 0 && result.roles[0].name !== 'super_admin') {
              localStorage.setItem('agreement_flag', result.agreement);
            }
            Vue.$toast.success('Login successful!', { position: 'top-right' });
            this.$router.push('/admin/dashboard');
            // Reload so the axios instance gets the new token in its headers
            location.reload();
          } else if (this.selectedPortal === 'referring' || this.selectedPortal === 'sales') {
            localStorage.setItem('is_admin', '0');
            localStorage.setItem('user_flag', data.data.flag || this.selectedPortal);
            Vue.$toast.success('Login successful!', { position: 'top-right' });
            setTimeout(() => {
              this.$router.push('/dashboard');
            }, 1000);
          } else if (this.selectedPortal === 'lead') {
            localStorage.setItem('is_admin', '0');
            localStorage.setItem('user_flag', 'lead');
            Vue.$toast.success('Login successful!', { position: 'top-right' });
            this.$router.push('/lead/dashboard');
          }
        } else {
          Vue.$toast.error(data.message || 'Invalid Email/Password', { position: 'top-right' });
        }
      } catch (error) {
        console.error('Login error:', error);
        Vue.$toast.error(error.response?.data?.message || 'Login failed. Please try again.', { position: 'top-right' });
      } finally {
        this.loginLoading = false;
      }
    },
    gotohome: function () {
      this.$router.push({ name: "Home" });
    },
    getCompanyInfo(url) {
      axios({
        method: "POST",
        url: "/api/get-company-info",
        data: {
          url: url
        }
      })
        .then(response => {
          this.company = response.data.company;
          console.log(this.company);
          this.loadingFlag = true;
          this.loadingLogo = true;
        })
    },
checkFormSignup(){
  let flag = 1;
      if (!this.email) {
        Vue.$toast.error('Email is required', {
            position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
      }
      if (!this.password && flag == 1) {
        Vue.$toast.error('Password is required', {
            position: 'top-right'
        });
        this.$refs['password'].focus()
        flag = 0;
      }

      if (flag == 1) {
        localStorage.setItem('temp_email',this.email)
        localStorage.setItem('temp_pass',this.password)
        localStorage.setItem('email_verified',0)
        if(this.company)
          this.$router.push('/signup/'+this.url)
        else
          this.$router.push('/signup')
      }
},
forgotPass(){
    this.buttonFlag =true;
    this.isDark = false;
    axios({
          method: "POST",
           
          url: "/api/auth/forgot-password",
          data: {
            email: this.email,
          }
        })
          .then(response => {
                this.sendFlag = 1;
                Vue.$toast.success('Forgot Password Mail sent', {
                position: 'top-right'
                });
                this.buttonFlag =false;
                this.isDark = true;
                this.pageFlag = 'login';
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          })
},
gotosignup: function () {
    let self = this;
    self.$router.push('/signup');
},gotoGoogle(){
      let self = this;
        this.$router.push('/redirect/google');
        location.reload();
  },
  gotoMs(){
      let self = this;
        this.$router.push('/redirect/microsoft');
        location.reload();
  },
  gotoYahoo(){
      let self = this;
        this.$router.push('/redirect/yahoo');
        location.reload();
  },
/**
 * checkForm
 * login the user with valid email/pass
 */
checkForm: function(e) {
      var loginData = {};
      var header = {};
      let flag = 1;
      if (!this.email) {
        Vue.$toast.error('Email is required', {
            position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
      }
      if (!this.password && flag == 1) {
        Vue.$toast.error('Password is required', {
            position: 'top-right'
        });
        this.$refs['password'].focus()
        flag = 0;
      }

      if (flag == 1) {
        var email = this.email;
        axios({
          method: "POST",
           
          url: "/api/auth/login",
          data: {
            email: this.email,
            password: this.password,
          }
        })
          .then(response => {
            let data = response.data;
            if (data.flag == 1) {
              let result = data.data;
              if(result.roles.length > 1){
                localStorage.setItem('logged_in_email',this.email);
                localStorage.setItem('logged_in_password',btoa(this.password));
                this.$router.push("/choose-profile");
              }else{
                localStorage.setItem("token", data.token.token);
                localStorage.setItem("user_id", result.user_id);
                localStorage.setItem("email", result.email);
                localStorage.setItem("phone", result.phone_m);
                localStorage.setItem("name", result.first_name+' '+result.last_name);
                localStorage.setItem("is_admin",0);
                localStorage.setItem("role", JSON.stringify(result.roles[0]));

                // Check for redirect URL (from sweepstakes page)
                const redirectUrl = localStorage.getItem('redirect_after_login');
                if (redirectUrl) {
                  localStorage.removeItem('redirect_after_login');
                  this.$router.push(redirectUrl);
                } else {
                  // Redirect based on role
                  if (result.roles[0].name === 'lead') {
                    this.$router.push("/lead-dashboard");
                  } else {
                    this.$router.push("/dashboard");
                  }
                }
                location.reload();
              }
            } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          });
      } else {

      }
    }
  }
    
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap');

.login-app {
  min-height: 100vh;
  font-family: 'Open Sans', sans-serif;
}

.login-main {
  min-height: 100vh;
}

.login-background {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  position: relative;
}

.login-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(200, 210, 230, 0.15) 0%, rgba(180, 200, 220, 0.15) 100%);
  z-index: 0;
}

.logo-container {
  position: relative;
  z-index: 1;
  margin-top: 20px;
  margin-bottom: 20px;
}

.autosyncx-logo-img {
  max-height: 80px;
  width: auto;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
}

.autosyncx-logo {
  font-family: 'Arial Black', 'Helvetica Neue', sans-serif;
  font-size: 42px;
  font-weight: 900;
  color: #5B3E96;
  letter-spacing: 3px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.sync-text {
  color: #5B3E96;
}

.x-text {
  color: #5B3E96;
  font-style: italic;
}

.tm-text {
  font-size: 14px;
  vertical-align: super;
  color: #5B3E96;
}

.login-card {
  position: relative;
  z-index: 1;
  border-radius: 16px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px);
}

.card-accent-bar {
  height: 8px;
  background: linear-gradient(90deg, #5B3E96 0%, #6B4BA6 100%);
}

.card-content {
  padding: 24px 32px !important;
  font-family: 'Open Sans', sans-serif;
}

.welcome-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 26px;
  font-weight: 400;
  color: #333;
}

.brand-text {
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  color: #5B3E96;
}

.tm-small {
  font-size: 10px;
  vertical-align: super;
}

.subtitle {
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-size: 14px;
  font-weight: 400;
}

.portal-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.portal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.portal-label {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  color: #333;
  font-size: 15px;
}

.expand-icon {
  color: #666;
  font-size: 14px !important;
  transition: transform 0.3s ease;
}

.rotate-icon {
  transform: rotate(180deg);
}

.portal-options {
  max-height: 280px;
  overflow-y: auto;
}

.portal-option {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  font-family: 'Open Sans', sans-serif;
}

.portal-option:last-child {
  border-bottom: none;
}

.portal-option:hover {
  background: #f8f8f8;
}

.portal-option.selected {
  background: linear-gradient(90deg, #5B3E96 0%, #6B4BA6 100%);
  color: white;
}

.portal-icon {
  margin-right: 12px;
  font-size: 16px !important;
  color: #888;
}

.portal-icon.selected-icon {
  color: white !important;
}

.portal-name {
  flex: 1;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #555;
}

.portal-name strong {
  font-weight: 600;
}

.portal-name-italic {
  font-style: italic;
}

.portal-option.selected .portal-name {
  color: white;
}

.check-icon {
  color: white !important;
  font-size: 14px !important;
  margin-right: 8px;
}

.dropdown-icon {
  color: white !important;
  font-size: 14px !important;
}

/* Login Input Fields */
.login-input {
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 8px !important;
}

.login-input .v-input__slot {
  border-radius: 8px !important;
  min-height: 44px !important;
}

.login-input .v-icon {
  font-size: 16px !important;
  color: #888 !important;
}

/* Dark mode input styles - using deep selectors */
.dark-card .login-input.v-text-field--outlined > .v-input__control > .v-input__slot {
  background: rgba(40, 40, 60, 0.9) !important;
}

.dark-card .login-input.v-text-field--outlined fieldset {
  border-color: rgba(150, 150, 180, 0.5) !important;
}

.dark-card .login-input input,
.dark-card .login-input .v-text-field__slot input {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  caret-color: #ffffff !important;
}

.dark-card .login-input .v-label {
  color: rgba(200, 200, 220, 0.9) !important;
}

.dark-card .login-input .v-input__icon .v-icon {
  color: rgba(180, 180, 200, 0.9) !important;
}

.dark-card .login-input.v-input--is-focused fieldset {
  border-color: #9B7ED9 !important;
}

.forgot-link {
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #5B3E96;
  cursor: pointer;
  text-decoration: none;
}

.forgot-link:hover {
  text-decoration: underline;
}

.dark-card .forgot-link {
  color: #B8A0E0;
}

.login-btn {
  background: linear-gradient(90deg, #5B3E96 0%, #2A9D8F 100%) !important;
  color: white !important;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  text-transform: none !important;
  border-radius: 8px !important;
}

.login-btn:disabled {
  opacity: 0.6;
}

.signup-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #666;
}

.signup-link {
  font-family: 'Open Sans', sans-serif;
  color: #5B3E96;
  cursor: pointer;
  text-decoration: underline;
}

.signup-link:hover {
  text-decoration: underline;
}

.footer-text {
  position: relative;
  z-index: 1;
  margin-top: 30px;
  font-family: 'Open Sans', sans-serif;
  color: rgba(50, 50, 70, 0.7);
  font-size: 13px;
  text-align: center;
}

/* Mode Toggle Button */
.mode-toggle {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.mode-btn {
  background: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(5px);
  color: #333 !important;
}

.dark-mode .mode-btn {
  background: rgba(0, 0, 0, 0.3) !important;
  color: #fff !important;
}

/* Dark Mode Styles */
.dark-bg::before {
  background: linear-gradient(180deg, rgba(20, 20, 40, 0.15) 0%, rgba(10, 10, 30, 0.15) 100%) !important;
}

.dark-card {
  background: rgba(30, 30, 45, 0.85) !important;
}

.dark-card .welcome-title {
  color: #f0f0f0;
}

.dark-card .brand-text {
  color: #9B7ED9;
}

.dark-card .subtitle {
  color: #aaa;
}

.dark-card .portal-header {
  background: rgba(50, 50, 70, 0.8);
  border-color: rgba(100, 100, 120, 0.3);
}

.dark-card .portal-label {
  color: #e0e0e0;
}

.dark-card .expand-icon {
  color: #aaa;
}

.dark-card .portal-section {
  border-color: rgba(100, 100, 120, 0.3);
}

.dark-card .portal-option {
  border-color: rgba(80, 80, 100, 0.3);
}

.dark-card .portal-option:hover {
  background: rgba(60, 60, 80, 0.5);
}

.dark-card .portal-name {
  color: #ccc;
}

.dark-card .portal-icon {
  color: #888;
}

.dark-card .signup-text {
  color: #aaa;
}

.dark-card .signup-link {
  color: #9B7ED9;
}

.dark-mode .footer-text {
  color: rgba(200, 200, 220, 0.7);
}

/* Responsive */
@media (max-width: 600px) {
  .autosyncx-logo {
    font-size: 28px;
  }

  .autosyncx-logo-img {
    max-height: 60px;
  }

  .welcome-title {
    font-size: 20px;
  }

  .card-content {
    padding: 16px 20px !important;
  }
}
</style>